import React from 'react';
import classes from './input.module.scss';

const Input = (props: any) => {
  const { error, label, value, changed, focused, unfocused, ...rest } = props;
  const inputClasses = [classes.input];
  if (props.error && props.error !== '') {
    inputClasses.push(classes.inputError);
  }
  return (
    <div className={classes.fieldContainer}>
      <label>
        <span className={classes.inputLabelText}>{label}</span>
        <input
          data-e2e-id={`${props.name}-input`}
          className={inputClasses.join(' ')}
          value={value || ""}
          onChange={changed}
          onFocus={focused}
          onBlur={unfocused}
          {...rest}
        />
      </label>
      {error && error !== '' ? (
        <p
          data-e2e-id={`${props.name}-errorMessage`}
          className={classes.errorMessage}
        >
          {error}
        </p>
      ) : null}
    </div>
  );
};

export default Input;
